import { BASE_URL, request } from "./api";
import type {
  Payment,
  PaymentRequestDto,
  PaymentUpdateRequestDto,
  PaymentMethod,
  PaymentMethodRequestDto,
  PaymentMethodUpdateRequestDto,
  Bank,
  BankRequestDto,
  BankUpdateRequestDto,
} from "./types";

// Re-export types
export type { Payment, PaymentMethod, Bank };

// ======== PAYMENT ========

// GET /api/Payments
export const getPayments = async (): Promise<Payment[]> => {
  return request<Payment[]>(`${BASE_URL}/api/Payments`, { method: "GET" });
};

// POST /api/Payments
export const createPayment = async (data: PaymentRequestDto): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Payments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// GET /api/Payments/{id}
export const getPaymentById = async (id: number): Promise<Payment> => {
  return request<Payment>(`${BASE_URL}/api/Payments/${id}`, { method: "GET" });
};

// PUT /api/Payments/{id}
export const updatePayment = async (
  id: number,
  data: PaymentUpdateRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Payments/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// DELETE /api/Payments/{id}
export const deletePayment = async (id: number): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Payments/${id}`, {
    method: "DELETE",
  });
};

// ======== PAYMENT METHOD ========

// GET /api/PaymentMethod
export const getPaymentMethods = async (): Promise<PaymentMethod[]> => {
  return request<PaymentMethod[]>(`${BASE_URL}/api/PaymentMethod`, {
    method: "GET",
  });
};

// POST /api/PaymentMethod
export const createPaymentMethod = async (
  data: PaymentMethodRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/PaymentMethod`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// GET /api/PaymentMethod/{id}
export const getPaymentMethodById = async (
  id: number
): Promise<PaymentMethod> => {
  return request<PaymentMethod>(`${BASE_URL}/api/PaymentMethod/${id}`, {
    method: "GET",
  });
};

// PUT /api/PaymentMethod/{id}
export const updatePaymentMethod = async (
  id: number,
  data: PaymentMethodUpdateRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/PaymentMethod/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// DELETE /api/PaymentMethod/{id}
export const deletePaymentMethod = async (id: number): Promise<void> => {
  return request<void>(`${BASE_URL}/api/PaymentMethod/${id}`, {
    method: "DELETE",
  });
};

// ======== BANK ========

// GET /api/Bank
export const getBanks = async (): Promise<Bank[]> => {
  return request<Bank[]>(`${BASE_URL}/api/Bank`, { method: "GET" });
};

// POST /api/Bank
export const createBank = async (data: BankRequestDto): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Bank`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// GET /api/Bank/{id}
export const getBankById = async (id: number): Promise<Bank> => {
  return request<Bank>(`${BASE_URL}/api/Bank/${id}`, { method: "GET" });
};

// PUT /api/Bank/{id}
export const updateBank = async (
  id: number,
  data: BankUpdateRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Bank/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// DELETE /api/Bank/{id}
export const deleteBank = async (id: number): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Bank/${id}`, {
    method: "DELETE",
  });
};

// ======== FETCH HELPERS ========

export const fetchPayments = () =>
  request<Payment[]>(`${BASE_URL}/api/Payments`, { method: "GET" });

export const fetchPaymentMethods = () =>
  request<PaymentMethod[]>(`${BASE_URL}/api/PaymentMethod`, { method: "GET" });

export const fetchBanks = () =>
  request<Bank[]>(`${BASE_URL}/api/Bank`, { method: "GET" });
